import { Box } from 'app/components/design-system-components'
import { CheckboxesList } from 'app/components/design-system-components/list-filters/CheckboxesList'
import { DropdownBodySectionHeader } from 'app/components/design-system-components/list-filters/DropdownBodySectionHeader'
import { theme } from 'app/match/applicationReportPDF/assets/theme'

const mgmtTypeFilterFields = {
  mgmtType: 'mgmtType',
}

const allStatusOption = {
  option: 'isAll',
  optionMeta: { id: 'isAll', displayText: 'All' },
}

export const mgmtTypeFilterDataExtractor = (filterValues: any) => {
  const { [mgmtTypeFilterFields.mgmtType]: mgmtTypeObj } = filterValues
  return {
    mgmtType: Object.values(mgmtTypeObj || {}).map(
      (value: any) => value.option,
    ),
  }
}

export const mgmtTypeActionsKeys = {
  isAll: 'isAll',
  isNewMgmt: 'isNewMgmt',
  isRelet: 'isRelet',
  isNA: 'isNA',
}

export const mgmtTypeActions = {
  isAll: 'All',
  isNA: 'N/A',
  isNewMgmt: 'New Management',
  isRelet: 'Re-let',
}

export const MgmtFilAppliedFilterRenderer = ({
  filterValues,
}: {
  filterValues: any
}) => {
  const { [mgmtTypeFilterFields.mgmtType]: actionObj } = filterValues
  return (
    Object.values(actionObj || {})
      // @ts-ignore
      .map((actionOption) => actionOption?.optionMeta?.displayText)
      .join(', ')
  )
}

export const isMgmtTypeFilterApplied = (mgmtTypeFilterValues: any) => {
  return (
    mgmtTypeFilterValues &&
    mgmtTypeFilterValues[mgmtTypeFilterFields.mgmtType] &&
    Object.values(mgmtTypeFilterValues[mgmtTypeFilterFields.mgmtType]).length
  )
}

interface FormBag {
  values: { [key: string]: any }
  setFieldValue: (field: string, value: any) => void
}

export const MgmtTypeFilterBody = ({
  formBag: { values, setFieldValue },
}: {
  formBag: FormBag
}) => {
  const options = Object.entries(mgmtTypeActions).map(([id, label]) => {
    return {
      option: id,
      optionMeta: {
        id,
        displayText: label,
      },
    }
  })

  const selectedValues = values[mgmtTypeFilterFields.mgmtType] || {}

  const onCheckboxClicked = (
    checked: boolean,
    option: { option: string; optionMeta: { id: string; displayText: string } },
  ) => {
    if (option.optionMeta.id === mgmtTypeActionsKeys.isAll) {
      toggleAll(checked)
      return
    }
    if (checked) {
      const allFilters = {
        ...selectedValues,
        [option.optionMeta.id]: option,
      }

      const { ...restFilters } = allFilters
      setFieldValue(mgmtTypeFilterFields.mgmtType, {
        ...restFilters,
      })
    } else {
      const {
        [option.optionMeta.id]: uncheckedOption,
        [allStatusOption.optionMeta.id]: allOption,
        ...otherOptions
      } = selectedValues
      setFieldValue(mgmtTypeFilterFields.mgmtType, {
        ...otherOptions,
      })
    }
  }

  const sourcesOptions = Object.values(mgmtTypeActionsKeys).map((mgmtType) => ({
    option: mgmtType,
    optionMeta: {
      id: mgmtType,
      displayText: mgmtTypeActions[mgmtType as keyof typeof mgmtTypeActions],
    },
  }))

  const toggleAll = (checked: boolean) => {
    if (checked) {
      setFieldValue(
        mgmtTypeFilterFields.mgmtType,
        Object.assign(
          {},
          ...sourcesOptions.map((option) => ({
            [option.optionMeta.id]: option,
          })),
        ),
      )
    } else {
      setFieldValue(mgmtTypeFilterFields.mgmtType, {})
    }
  }

  return (
    <Box minWidth="200px" maxHeight="300px" overflowY="auto">
      <DropdownBodySectionHeader
        header="Management Type"
        containerProps={{ mb: theme.space[4] + 'px' }}
      />

      <CheckboxesList
        options={options}
        checkedOptions={selectedValues}
        onCheckBoxClicked={onCheckboxClicked}
      />
    </Box>
  )
}
